module.exports = __webpack_public_path__ + "f2f36d314eb80a913dd5ba6d7c72f809.pdf";